import type { FC } from 'react'
import React from 'react'
import styled from 'styled-components'

import Card from '@/components/Card'
import SmallPill from '@/components/SmallPill'

import type { FilterT } from './Filter'
import Filter, { DEFAULT_FILTER } from './Filter'

export interface SearchValues {
  filter: FilterT
}

export const DEFAULT_SEARCH: SearchValues = {
  filter: DEFAULT_FILTER,
}

export interface Props {
  searchValues: SearchValues
  onChangeSearchValues: (searchValues: SearchValues) => void
  onSubmitSearchValues: (searchValues: SearchValues) => void
}

const Container = styled(Card)`
  padding: 15px;
  display: grid;
  grid-template-rows: 1fr min-content min-content;
  grid-row-gap: 20px;
  min-width: 290px;
  min-height: 0;
  align-self: start;
`

const SubmitContainer = styled.div`
  justify-self: end;
`

const FilterPanel: FC<Props> = ({
  searchValues,
  onChangeSearchValues,
  onSubmitSearchValues,
}) => (
  <Container>
    <Filter
      filter={searchValues.filter}
      onChangeFilter={newFilter =>
        onChangeSearchValues({
          ...searchValues,
          filter: newFilter,
        })
      }
    />
    <SubmitContainer>
      <SmallPill onClick={() => onSubmitSearchValues(searchValues)}>Search</SmallPill>
    </SubmitContainer>
  </Container>
)

export default FilterPanel
